import { render, staticRenderFns } from "./detectionContent.vue?vue&type=template&id=5b37149a&scoped=true"
import script from "./detectionContent.vue?vue&type=script&lang=js"
export * from "./detectionContent.vue?vue&type=script&lang=js"
import style0 from "./detectionContent.vue?vue&type=style&index=0&id=5b37149a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b37149a",
  null
  
)

export default component.exports